import Callout from "@/components/docs/Callout";
import SectionCard from "@/components/docs/SectionCard";

export function useMDXComponents(components: any) {
  return {
    Callout,
    SectionCard,
    ...components,
  };
}
